import { TextField, TextFieldProps } from '@mui/material';

export function BaseTextInput(props: TextFieldProps) {
    return <TextField slotProps={{ input: { readOnly: true } }} {...props} />;
}
